// @flow
import { BaseChartRenderer } from './base-chart.renderer';
import { ChartModel } from './chart.model';



export class ChartPreviewRenderer extends BaseChartRenderer {
    constructor (chart: ChartModel, width: number, height: number) {
        super(chart, width, height, 1);
        const _max = this.chart.getMaxValue();
        this.chartMax = _max * 10;
        this.update({ chartMax: _max });
    }
    render () {
        super.render();
        const { width, height } = this.canvas;
        const step = width / this.chart.row.data.length;
        this.context.fillStyle = 'rgba(30, 30, 30, 0.1)';
        this.context.strokeStyle = 'rgba(125, 125, 125, 0.5)';
        const start = step * this.chart.selectStart;
        const end = (step * this.chart.selectEnd);
        const w = end - start;

        this.context.strokeRect(start + 10, 0, w - 20, height);
        this.context.fillRect(0, 0, start + 5, height);
        this.context.fillRect(end - 5, 0, width, height);
        this.context.fillStyle = 'rgba(30, 30, 30, 0.3)';
    }
}
